module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("CHAPTER ONE")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_c('span', [_vm._v("G"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("IANNI")])]), _vm._v(" F"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("IRELLI")])])])]), _vm._v(" was restless.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It was six o’clock on a warm May evening and he’d been trapped at the party celebrating the birth of Stefano Lucchesi’s child for what seemed forever.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The room was too crowded, the voices too loud, and if anyone stuck one more squalling baby under his nose, he was going to forget that the expected response to such an affront on a man’s eardrums was a smile. Between babies-in-bellies and babies-in-blankets, there were almost enough kids here to field a football team.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It looked as if Stefano had married into a fertile clan.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As if that weren’t enough, an hour ago, Tomasso Massini, one of Gianni’s oldest friends, had shown up with his wife. His extremely pregnant wife.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("You, too, Tommy?")])]), _vm._v(" Gianni had thought even as he shook his hand, kissed the wife and said all the right things.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The sexy blonde with the endless legs was the only diversion Gianni had seen, but she’d turned out to be as rude as she was easy on the eyes.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Sighing, he cast a surreptitious glance at his watch. Another few minutes and he could make a polite exit. Until then, he’d smile, say the right things, and try to figure out what in God’s name had impelled Stefano to give up his freedom and become not just a husband but also a daddy.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Gianni had nothing against marriage or babies. Someday, he supposed, he’d settle down, marry and have a couple of children of his own, but that was way in the future.")])])]), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Not yet, though. It was much too soon.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Stefano and Tomasso seemed happy enough, but that didn’t keep him from puzzling over why two sane men would give up their freedom when they were only in their thirties.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Was it something in the air?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He’d almost said that to Tomasso, but you didn’t joke with a man whose wife had a belly the size of a boulder, not even if you’d known him since you were ten. He, Tommy and Stefano had grown up together on the crowded streets of Manhattan’s Little Italy. Their paths didn’t cross often anymore but they were there for each other when it mattered.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Obviously babies mattered.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Somebody—one of Stefano’s new brothers-in-law—brushed past him, a screaming infant in his arms. A smell wafted from the child.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It wasn’t baby powder.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Sorry,” the guy said, and grinned.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Gianni managed a smile in return. “No problem,” he said, and headed for the terrace where he took a deep, deep breath of fresh air. Okay. He’d stay out here where he could enjoy a little quiet along with the view of Central Park forty stories below and think about whether he wanted to see Lynda tonight without having to pretend he was delighted that his two best friends had obviously lost their minds.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Maybe he should have stayed with his instincts and opted out of this party. He’d been tempted to send a gift from Tiffany’s, tuck in a note explaining how sorry he was he couldn’t make it in person, etc., etc., etc., but how could he not show up at this celebration for Stefano’s child? He’d missed the wedding—bad weather that shut down all the airports had seen to that.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("So, he was here.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The blonde with the up-to-her-ears legs was here, too.")])])]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Gianni scowled. Was he back to that? Well, there was nothing else to think about. The lady had made an impression. A negative one. And, since he hadn’t come up with much else to do after he’d made the rounds, his thoughts naturally returned to her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He’d had a toothache once. Try as he had, he couldn’t keep the tip of his tongue from returning to the offending molar.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("This was the same ridiculous thing.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Gianni looked into the Lucchesis’ enormous living room. There she was now, talking animatedly with Tomasso’s wife, Karen, as if they were old friends. She smiled, she touched Karen’s arm, she even grinned.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She hadn’t even managed a tilt of the lips for him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Not that he cared. She wasn’t his type at all. He preferred his women petite, dark-haired and quintessentially feminine. Lynda met those standards. She was also all curves, where the blonde was as skinny as a boy. Lynda smiled when a man smiled at her. The blonde didn’t. She meted out favors with the stinginess of a miser opening his purse.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A waiter stepped out on the terrace. “Something to drink, sir?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Gianni nodded, took a glass of red wine from the tray and raised it to his lips.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He and the blonde had arrived in the lobby at the same time. The doors of the private elevator for the penthouse were closing when he heard a voice call out.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hey,” a woman said.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A slim hand had thrust between the doors.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Gianni hit the button that reversed the doors’ direction. They opened, and he saw the blonde.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Not my type")])]), _vm._v(", was his first thought.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He gave her a polite smile. “Sorry. I didn’t see you coming.”")])])]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She gave him a long look. Her expression was one of suspicion.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“This is a private elevator,” she said.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Gianni’s smile tilted. “Indeed it is.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It only goes to the penthouse.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“How convenient,” he said dryly. “That happens to be where I’m going.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Did the doorman—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Perhaps you’d like to see my driver’s license, passport and birth certificate,” he said, his smile fading. “Or perhaps I should ask to see yours.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("That, at least, had put a stain of color across the arcs of her high cheekbones.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m going to the Lucchesi party.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“So am I. Or, at least, I will once you step inside and the doors shut.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She entered the elevator and stood beside him, eyes straight ahead. Okay. He’d decided to give it another try.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Are you a friend of Fallon’s?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No,” she said, without looking at him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Stefano’s?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Then are you with—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I don’t see that it’s any of your affair,” she said, still staring straight ahead. Then she turned toward him, her eyes cold as ice. “Besides, I’m not interested.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It was his turn to be the one whose face stung with heat.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I assure you,” he said, “I’m not—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The elevator stopped, the doors opened. Gianni stepped out first without waiting for the woman to precede him. It was a good thing the car opened directly into Stefano’s foyer. He wasn’t sure what he’d have done if they’d ended up in front of an apartment door and he’d had to decide whether to ring the bell or tell her she could go straight to hell.")])])]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Pathetic, he knew. Even more pathetic that she’d reduced him to such childish musings. He’d almost told her what he was thinking but he’d spotted Stefano coming toward him and he’d smiled, only to have the blonde sweep past him, give a little squeal of delight and run straight into Stefano’s arms.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Stefano,” she’d cried happily, and Gianni, mouth thinning in disgust, had let himself blend into the crowd.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Apparently the Ice Princess reserved her smile solely for a favored few.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Now, watching her, he saw her flash that smile for Stefano’s wife and baby daughter as she took the child from Fallon’s arms. He saw her lips purse as if she were cooing. The baby kicked its legs and the blonde not only smiled again, but she threw back her head and laughed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It was quite a laugh. Husky. Throaty. Under the right circumstances, he suspected that laugh would be sexy as hell.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Gianni narrowed his eyes.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He could see he’d made some errors about the woman. They were unimportant, given the circumstances, but he was a man who liked to get the details straight. Her hair wasn’t blond, it was half a dozen shades of palest gold. And she wasn’t skinny. Slender, yes, but with rounded hips and a nicely defined backside.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And when, still laughing, she hoisted the baby high in the air, her breasts lifted and only a blind man wouldn’t have noticed that they were round and full…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And not confined by a bra.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The pale green silk dress clung to her body just enough so he could see the outline of her nipples.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("What were they like? Small? Large? What color would they be? Rosebud-pink, he imagined, like her mouth. Soft to the touch, silken and responsive. They’d tighten under his caress, bloom under the laving of his tongue…")])])]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Hell, what was he doing?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("This was a christening, not a stag party. And wasn’t it a good thing he was on the terrace so he could turn his back to the room, because his wandering thoughts were having an all-too-predictable effect on his anatomy.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Gianni concentrated on the Manhattan skyline, bathed now in the variegated orange hues of the setting sun, but thinking about the colors of things wasn’t a good idea right now. It took him straight back to the blonde’s breasts.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Green was a better color. The green of the boxwood, growing in some of the terrace’s many planters.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The green silk of the woman’s dress and the way it molded to her…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“She’s beautiful, isn’t she?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Stefano had come up beside him, grinning, holding out a bottle of wine. Gianni nodded and held out his glass for a refill.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Was it that obvious?” he said with a rueful smile.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Are you kidding? Of course.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Gianni sighed. “Thanks a lot.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hey, I’m only speaking the truth.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Easy for you to say, Lucchesi.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Well, sure, but who wouldn’t react to such beauty?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Let’s not go overboard here,” Gianni said. “She’s attractive, assuming you like the type.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Attractive?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes. You know, she’s got all the right equipment in all the right places.” Stefano was looking at him as if he’d lost his mind. He thought back to how the blonde had greeted his old friend, married or not. “But that doesn’t make her gorgeous.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“That’s a joke, right?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Why would I joke? I’m dead serious. Plus, she’s got all the charm of a tarantula.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', [_vm._v("Stefano’s expression turned grim. “You’d better be glad ")])]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("you and I’ve been friends since P.S. 26, Firelli, or I’d pin your ears back.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("“What wrong with you, man? You’d take me on because I don’t agree a woman’s gorgeous?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("“Damned right I would. This particular woman is—this woman is…” Stefano’s eyebrows rose again. “What woman?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("Was this what happened to a man when he married and had a child? Did he lose his sanity as well as his freedom?")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("“The blonde, of course,” Gianni said impatiently. “The one who greeted you with such, uh, warmth…and, by the way, doesn’t Fallon object to that kind of thing?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("Stefano’s eyes widened. Then he threw back his head and roared with laughter.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("“Wonderful,” Gianni said coldly. “I’m glad you think this is—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("“The blonde,” Stefano gasped. “Oh my God, the blonde!”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("“That’s it.” Gianni slapped his glass on a nearby table and started toward the doors.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("Stefano grabbed his arm. “Where are you going, you idiot?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("“Lucchesi,” Gianni said through his teeth, “I’d hate to wipe up the floor with you while your guests watch, but so help me—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("“I was talking about my daughter!”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("“Yes. And I told you…” Gianni blinked. “Your daughter?” He felt the color rise in his face. “You were talking about—about—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("“About Cristina. Of course. And you thought I was talking about a woman.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("“Hell.” Gianni turned away, leaned his arms on the terrace railing and stared blindly into the gathering dusk. Things were going from bad to worse. “You’re right,” he mumbled. “I’m an idiot.”")])])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Stefano chuckled. “I’m happy we agree.” The men fell silent for a minute. Then Stefano cleared his throat. “So, which blonde are we talking about?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It doesn’t matter,” Gianni said, waving his hand in dismissal. A couple of seconds went by. “The one who damned near threw herself into your arms when she got here.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Not a very good description, Firelli. All women throw themselves into my arms.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Gianni chuckled. “Better not let your wife hear you say that.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Better not let his wife hear what?” Fallon said, smiling as she joined the men. “Gianni, it’s good to see you again.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Gianni smiled and kissed her cheek. “And you, Fallon. Motherhood has made you even lovelier. I wouldn’t have thought that possible.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Fallon batted her lashes. “You Sicilians! You always know how to make a woman feel good.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Some women,” Stefano said. Fallon raised her eyebrows. “It seems one of our guests turned down the chance to have her name added to Gianni’s little black book.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Stefano,” Gianni said warningly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Stefano slipped his arm around his wife. “Come on, don’t be shy. If you’re interested in one of our guests—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m not,” Gianni said quickly. “I only said—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Point her out,” Fallon said. “I’ll introduce you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Gianni looked at Stefano, who was grinning from ear to ear. “Damn it, Lucchesi! Fallon, your husband’s letting his imagination run away with him.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I know who she is,” Stefano said, as if Gianni weren’t there.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You don’t,” Gianni said quickly. How in hell had this gotten away from him so fast? “There must be half a dozen blondes at this party.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“But you said this one threw herself into my arms.”")])])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“And?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“And that she was attractive.” Stefano winked at his wife. “Attractive, mind you, but not beautiful.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What,” Gianni said coldly, “is your point?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“My point,” Stefano said smugly, “is that I know who she is.” He paused, just long enough so that Fallon and Gianni gave him their full attention. “The lady in question is my sister-in-law.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Gianni stared at his old friend. “Your—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“He was talking about Briana,” Stefano told Fallon. “And why would a man who thinks a woman is attractive but not beautiful be fixated on her?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I am not fixated on her. I’ve never found that type of woman interest…Oh, hell. I’m killing myself here, aren’t I?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes,” Fallon said agreeably. She let go of her husband and linked her arm through Gianni’s. “And the only way out is to let me introduce you to Bree so you can find just what, exactly, it is you never find interesting.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Stefano and Fallon were laughing, so he laughed, too, or tried to, as she all but dragged him into the crowded room. Thank God, he thought, after a quick look around. Bree or Briana, whatever her name was, was gone.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’d love to meet her,” he said, lying through his teeth. “Too bad she seems to have left.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“She went upstairs to diaper the baby,” Fallon said, heading for the curving staircase that led to the penthouse’s upper level, “and I’m not going to let you back out of this.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Fallon. Look, I’m sorry. I shouldn’t have said what I said about your sister. I’m sure she’s charming. Beautiful, too. And—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Bree,” Fallon said, “there you are,” and Gianni turned from his hostess and looked at the woman coming down the steps toward them.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He’d gotten it right the first time.")])])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Briana O’Connell wasn’t beautiful.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She was spectacular.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("All that blond hair, tumbling over her shoulders to frame a face dominated by sea-blue eyes. That mouth, yes, rosebud-pink and just full enough to make him wonder how it would feel to sink into its soft warmth. The high breasts, slender waist, delicately rounded hips and long, hell, endless legs.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("At least she wasn’t trying to freeze him with a look. How could she, when she gave him a glance that lasted no more than a second?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Bree, this is Gianni Firelli. Gianni, my baby sister, Bree.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It’s Briana,” the blond vision said, and turned her attention to Fallon. “The baby fell asleep as soon as I put her in her bassinet. I left her with her nanny. Is that all right?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It’s fine. Uh, Bree? Gianni’s one of Stefano’s oldest friends.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("This time, Gianni got the full force of her icy gaze. “How nice for them both. If you’ll excuse me…”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Why should I excuse you?” he said, before he could stop himself. He stepped away from Fallon, moved closer to Briana and pitched his voice slow enough that only she would hear him. “Are you always so rude, or is this personal?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Those deep blue eyes met his and suddenly he saw something in their depths, a flash of heat so intense it threatened to sear his soul.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You flatter yourself,” she whispered.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And then she was gone.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Gianni had never understood what people meant when they said their blood was boiling, but he understood it now. He stared after her, imagined the pleasure of going after her, grabbing her and shaking her until she begged for mercy…")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("Or of swinging her into his arms, carrying her away, tak")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("ing her to a room where he could strip her of that green dress and that icy look, put his hands in her hair and kiss her until she was helpless and pleading for more…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("“I’m terribly sorry, Gianni.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("He blinked, focused his eyes on Fallon’s face. She looked as shocked as he felt.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("“Bree’s not—She’s not a rude person. I don’t know what came over her.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("Summoning a smile wasn’t easy, but he managed. “It’s all right.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("“No, it’s not. Look, let me go find her and—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("“No.” His voice was sharp. Carefully he manufactured another smile and started over. “Really, Fallon, I’m not offended.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("“Well, you should be. When I get her alone later—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("“Forget it. Maybe she had a difficult day.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("“Bree? A difficult day?” Fallon gave a ladylike snort. “I don’t know how. My sister doesn’t do anything that might be considered difficult.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("Except treat men as if they were contemptible, Gianni thought, but he wasn’t going to say anything like that. Her sister’s behavior wasn’t Fallon’s responsibility.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("“Doesn’t she have a job?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("“An endless succession of them. She’s been a photographer, a travel consultant, a salesclerk, a game show research assistant…” Fallon smiled. “Our mother says she’s still finding herself but to be honest, my other sister and I don’t think she ever lost herself in the first place. She’s just, well, flighty.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("It was a nice way of saying Briana O’Connell was unreliable, not just rude and sullen. The woman wouldn’t be any sane man’s type, let alone his.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("“Fallon,” he said, taking his hostess’s hands in his, “I’ve had a wonderful afternoon.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("“You’re not leaving?”")])])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He smiled and brought her hands to his lips, pressed a light kiss to the back of each.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m afraid I must. I have a dinner appointment this evening.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Ah. Too bad. Stefano and I hoped you’d stay after the others left. He loves to talk about old times with you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Another time, I promise. Make my goodbyes to him, will you?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes, absolutely.” Fallon linked her arm through his as they walked slowly through the foyer. “And Gianni…I’m really terribly sorry about my sister.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No need. I’ve been rebuffed before.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Fallon laughed, turned to him and cupped his face in her hands.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You’re a bad liar, Gianni Firelli. We both know that there’s not a woman alive who wouldn’t do a maidenlike swoon if you smiled in her direction.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“From your lips to God’s ear,” he said lightly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She laughed again, rose on her toes and pressed a demure kiss to his lips.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It was good seeing you. And thank you for the beautiful gift for Cristina.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“My pleasure. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Ciao")])]), _vm._v(", Fallon.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Goodbye, Gianni.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The elevator was waiting. He stepped inside, kept smiling until the car doors closed. Then he let the scowl he’d been fighting darken his face as he took his cell phone from his pocket.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lynda answered on the first ring. “Hello,” she said in that breathless whisper that always made his muscles tighten.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Strangely enough, they didn’t tighten this time.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It’s me.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Gianni.” Her whisper became a purr. “I hoped you’d call. Are you coming over?”")])])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The elevator reached the lobby. He stepped briskly from the car, nodded to the doorman when he opened the door that led to the street.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Let’s have dinner.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Of course, darling. Are we going out? Shall I put on something pretty…Or shall I stay as I am? I just took a bath and all I’m wearing is that pink silk robe you gave me.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Pink. Rosebud-pink, like Briana O’Connell’s mouth.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Gianni? Can you hear me?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He cleared his throat. “I hear you, Lynda.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What do you want to do? We could try that new restaurant everyone’s talking about. You know, Green Meadows. It’s supposed to be spectacular.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Green, like the dress that outlined Briana’s supple body. Spectacular, like her magnificent face…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Gianni?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("All at once, Gianni knew what he wanted to do. It had nothing to do with Briana O’Connell. Nothing at all. It was just something that had been coming for a few weeks, and it was time he dealt with it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Lynda?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Don’t bother making reservations. I’ll be there in twenty minutes.” He paused. “And get dressed,” he added gently. “All right?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He heard the swift intake of her breath. “Gianni? Is everything all right?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Twenty minutes,” he said, and pressed the disconnect button.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("An hour later, he left Lynda’s apartment for the last time. She was crying and he hated knowing he’d made that happen but at the very start of their relationship they’d agreed neither of them was interested in commitment, and that when the time came to end things, they’d do it with honesty.")])])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I know,” she’d said tearfully, when he’d reminded her of that, “but I thought things had changed.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nothing had changed. It never did. Women always said one thing at the start of a relationship and another at its end.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Gianni sighed. Darkness had finally claimed the city and he was eager to get home, take a long shower and put the strange day behind him. He thought of hailing a cab, then decided he’d rather walk.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Tomorrow, he’d send Lynda something to cheer her. A bracelet, perhaps. Something expensive enough to assuage her tears and his guilty conscience because honesty was one thing, but dissolving a relationship with no warning was another.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The truth was, he really hadn’t thought about ending things until a little while ago. He’d been satisfied enough until he’d gone to that damned party. Until he’d looked into the eyes of a woman who didn’t seem to care that he existed and saw, in those eyes, something else.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("That one swift, blinding flash of heat.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A sharp wind blew down 57th Street, surprisingly cold after the warmth of the day. Gianni turned up the collar of his jacket, tucked his hands deep in his pockets and picked up his pace.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f996adac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sicilianmarriagethe_ch01.vue
// module id = 69
// module chunks = 0